import { hasText } from '~/utils';
import { formatAddressText, type AddressLike } from '~/utils/addressFormat';

type LabelableFacility = {
  code?: string | null;
  address: { city: string };
  locations: { branchCode?: string | null }[];
};

export function facilityDisplayLabel(facility: LabelableFacility): string {
  if (hasText(facility.code)) {
    return facility.code.trim();
  }
  const branchCodes = [
    ...new Set(
      facility.locations
        .map((location) => location.branchCode?.trim())
        .filter(hasText)
    ),
  ];
  const [onlyBranchCode] = branchCodes;
  return branchCodes.length === 1 && onlyBranchCode
    ? onlyBranchCode
    : facility.address.city;
}

type AddressOptionFacility = {
  code?: string | null;
  address: AddressLike;
};

export function addressOptionLabel(facility: AddressOptionFacility): string {
  const addressText = formatAddressText(facility.address);
  return hasText(facility.code)
    ? `${facility.code.trim()} · ${addressText}`
    : addressText;
}
